import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-define-service',
  templateUrl: './define-service.component.html',
  styleUrls: ['./define-service.component.css']
})
export class DefineServiceComponent implements OnInit {

  data: any;
  cid:any
  form: any | FormGroup
  viewform: any | FormGroup
  serviceData: any = [];
  singleServiceData: any = [];
  serviceKeyValue: any = [];
  formSubmit = false;
  addbutton = true;
  file: any;
  serviceId: any = ""
  isLoading: any = false
  pageNumber: number = 0;
  recordsPerPage: number = 10;
  totalRecords: number = 0;
  first: number = 0;
  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  searchUser: any = ""

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
      // this.getAllServices()
      this.getAllServicesWithPagination(this.pageNumber,this.recordsPerPage)

      this.form = this.fb.group({
        name: ['',[Validators.required]],
        serviceId: [''],
        description: ['',[Validators.required]],
        imageUrl: ['',[Validators.required]]
      })
  }

  onTableDataChange(event: any) {

    this.pageNumber = event.page;
    this.recordsPerPage = event.rows;


    if(this.searchUser != ""){
      this.getServiceDefinitionByWildSearch(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllServicesWithPagination(this.pageNumber,this.recordsPerPage);
    }
  }

 addService(){
  this.formSubmit = true;
  if(!this.form.valid){
    this.toastr.error('All Fields Required');

    return
  }
  this.addbutton = false;

  let body = {
    "version": 0,
    "isActive": true,
    "serviceId": String(this.form.get('serviceId').value),
    "description": String(this.form.get('description').value),
    "name": String(this.form.get('name').value),
    "imageUrl": String(this.form.get('imageUrl').value),
    "cid": Number(this.cid)
  }

  this.generic_service.addService(body).subscribe(
    (response:any)=>{
      console.log(response)
      this.getAllServicesWithPagination(this.pageNumber,this.recordsPerPage)
      this.toastr.success(response.message);
      this.cancelModel()
      this.form.reset()
      this.formSubmit = false;
      this.addbutton = true;
    },
    (err:any)=>{
      console.log(err)
      this.toastr.error(err.error.errors[0].description);
      this.formSubmit = false;
    },
  )
}

cancelModel(){
  document.getElementById("closeModalButton")?.click()
  document.getElementById("closeModalButton1")?.click()
  this.form.reset()
  this.formSubmit = false;
  this.addbutton = true;
}

getAllServicesWithPagination(pageNumber: any, recordsPerPage: any){
  this.isLoading = true

  this.generic_service.getAllServicesWithPagination(pageNumber, recordsPerPage).subscribe(
    (response:any)=>{
      this.serviceData = response.response.serviceDefinitionList;
      this.totalRecords = response.response.totalRecords;
      this.isLoading = false

      console.log(response)
    }
  )
}

getAllServices(){
  this.isLoading = true

  this.generic_service.getAllServices().subscribe(
    (response:any)=>{
      this.serviceData = response.response;
      this.isLoading = false

      console.log(response)
    }
  )
}

  getServiceById(id:any){
    this.generic_service.getServiceById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.singleServiceData = []
        this.singleServiceData.push(response.response)
      },
      (error)=>{
        console.log(error)
        this.singleServiceData = []
      }
    )
  }

  addImageBtn(){
    document.getElementById("add-image-btn")?.click()
  }

  onChange(event: any) {
    this.file = event.target.files[0];
    this.onUpload()
  }

  onUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.form.get('imageUrl').setValue(event.response)
    });
  }

  selectServiceId(id: any){
    this.serviceId = id;
  }

  deleteService(){
    this.generic_service.deleteService(this.serviceId).subscribe(
      (response: any) => {
        console.log(response)
        this.getAllServicesWithPagination(this.pageNumber,this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getServiceDefinitionByWildSearch(pageNumber: any,recordsPerPage: any){

    if(this.searchUser != ""){
      this.isLoading = true

      this.generic_service.getServiceDefinitionByWildSearch(this.searchUser,pageNumber,recordsPerPage).subscribe(
        (response:any)=>{
          console.log(response);
        
          this.serviceData = response.response.serviceDefinitionList;
          this.totalRecords = response.response.totalRecords;  
          this.isLoading = false

        },
        (err:any)=>{
          console.log(err)
        }
      )
    }else{
      this.getAllServicesWithPagination(this.pageNumber,this.recordsPerPage)
    }

  }

}